oyc.Modal = {
  scrollTop: null,
  htmlBody: document.documentElement,
  wrapper: document.querySelector('.page-wrapper'),
  originalParent: new Map(),
  _originalStyles: null,
  _scrollContainer: null,
  _isLocked: false,
  _savedBodyStyles: null,

  selectors: {
    modalButton: '[data-modal-target]',
    modalTarget: 'data-modal-target',
    modalCloseButton: '.modal-close-button',
    modalContainer: '.modal',
    iframe: 'iframe',
    video: 'video'
  },

  classes: {
    opened: 'is-opened',
    hidden: 'hidden'
  },

  init: function () {
    this._scrollContainer = document.scrollingElement || document.documentElement;
    this._originalStyles = '';

    const buttons = document.querySelectorAll(this.selectors.modalButton);

    buttons.forEach((button) => {
      const targetId = button.getAttribute(this.selectors.modalTarget);
      const overlay = document.getElementById(targetId);

      if (!overlay) return;

      const closeButton = overlay.querySelector(this.selectors.modalCloseButton);
      const modal = overlay.querySelector(this.selectors.modalContainer);

      button.addEventListener('click', () => {
        this.openModal(overlay, button);
      });

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.closeModal(overlay);
        });
      }

      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
          this.closeModal(overlay);
        }
      });
      overlay.addEventListener('close', () => {
        this.onDialogClosed(overlay);
      });
    });
  },

  openModal: function (overlay, triggerButton) {
    if (!overlay) return;

    if (!this.originalParent.has(overlay)) {
      this.originalParent.set(overlay, overlay.parentNode);
    }

    document.body.appendChild(overlay);

    if (overlay.open) {
      overlay.close();
    }

    this.lockBody();

    overlay.showModal();

    const closeButton = overlay.querySelector(this.selectors.modalCloseButton);
    if (closeButton) {
      requestAnimationFrame(() => {
        closeButton.focus();
      });
    }

    const event = new CustomEvent('modal:opened', {detail: {overlay, triggerButton}});
    document.dispatchEvent(event);
  },

  closeModal: function (overlay) {
    if (!overlay) return;

    overlay.close();
  },

  onDialogClosed: function (overlay) {
    if (this.originalParent.has(overlay)) {
      this.originalParent.get(overlay).appendChild(overlay);
    }

    if (document.querySelectorAll('dialog[open]').length === 0) {
      this.unlockBody();
    }

    overlay.dispatchEvent(new CustomEvent('modal:closed', {bubbles: true, detail: {overlay}}));
  },
  lockBody: function () {
    if (this._isLocked) return;

    this.scrollTop = this._scrollContainer ? this._scrollContainer.scrollTop : (window.pageYOffset || document.documentElement.scrollTop || 0);

    this._savedBodyStyles = {
      overflow: document.body.style.overflow || '',
      position: document.body.style.position || '',
      height: document.body.style.height || '',
      width: document.body.style.width || '',
      top: document.body.style.top || '',
      left: document.body.style.left || '',
      transform: document.body.style.transform || ''
    };

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.height = '100%';
    document.body.style.width = '100%';
    document.body.style.top = '-' + this.scrollTop + 'px';
    document.body.style.left = '50%';
    document.body.style.transform = 'translateX(-50%)';

    this.htmlBody.classList.add('opened-modal');
    this._isLocked = true;
  },

  unlockBody: function () {
    if (!this._isLocked) return;

    setTimeout(() => {
      this.htmlBody.classList.remove('opened-modal');
    }, 500);

    if (this._savedBodyStyles) {
      document.body.style.overflow = this._savedBodyStyles.overflow;
      document.body.style.position = this._savedBodyStyles.position;
      document.body.style.height   = this._savedBodyStyles.height;
      document.body.style.width    = this._savedBodyStyles.width;
      document.body.style.top      = this._savedBodyStyles.top;
      document.body.style.left     = this._savedBodyStyles.left;
      document.body.style.transform= this._savedBodyStyles.transform;
    } else {

      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.height   = '';
      document.body.style.width    = '';
      document.body.style.top      = '';
      document.body.style.left     = '';
      document.body.style.transform= '';
    }

    if (this._scrollContainer) {
      this._scrollContainer.scrollTop = this.scrollTop || 0;
    } else {
      window.scrollTo(0, this.scrollTop || 0);
    }

    this._isLocked = false;
  },
};
